/*
* <license header>
*/

import React, { createContext, useContext, useState, useEffect, useCallback } from 'react'

const STORAGE_KEY_APPS = 'appbuilder-factory-favorites'
const STORAGE_KEY_TYPES = 'appbuilder-factory-favorite-types'

const FavoritesContext = createContext(null)

export function FavoritesProvider ({ children }) {
  const [favoriteIds, setFavoriteIds] = useState(() => {
    try {
      const stored = localStorage.getItem(STORAGE_KEY_APPS)
      return stored ? JSON.parse(stored) : []
    } catch {
      return []
    }
  })

  const [favoriteTypeSlugs, setFavoriteTypeSlugs] = useState(() => {
    try {
      const stored = localStorage.getItem(STORAGE_KEY_TYPES)
      return stored ? JSON.parse(stored) : []
    } catch {
      return []
    }
  })

  useEffect(() => {
    try {
      localStorage.setItem(STORAGE_KEY_APPS, JSON.stringify(favoriteIds))
    } catch (e) {
      console.warn('Failed to persist app favorites', e)
    }
  }, [favoriteIds])

  useEffect(() => {
    try {
      localStorage.setItem(STORAGE_KEY_TYPES, JSON.stringify(favoriteTypeSlugs))
    } catch (e) {
      console.warn('Failed to persist type favorites', e)
    }
  }, [favoriteTypeSlugs])

  const toggleFavorite = useCallback((appId) => {
    setFavoriteIds((prev) =>
      prev.includes(appId) ? prev.filter((id) => id !== appId) : [...prev, appId]
    )
  }, [])

  const isFavorite = useCallback(
    (appId) => favoriteIds.includes(appId),
    [favoriteIds]
  )

  const toggleTypeFavorite = useCallback((slug) => {
    setFavoriteTypeSlugs((prev) =>
      prev.includes(slug) ? prev.filter((s) => s !== slug) : [...prev, slug]
    )
  }, [])

  const isTypeFavorite = useCallback(
    (slug) => favoriteTypeSlugs.includes(slug),
    [favoriteTypeSlugs]
  )

  const value = {
    favoriteIds,
    toggleFavorite,
    isFavorite,
    favoriteTypeSlugs,
    toggleTypeFavorite,
    isTypeFavorite
  }
  return (
    <FavoritesContext.Provider value={value}>
      {children}
    </FavoritesContext.Provider>
  )
}

export function useFavorites () {
  const ctx = useContext(FavoritesContext)
  if (!ctx) {
    throw new Error('useFavorites must be used within FavoritesProvider')
  }
  return ctx
}
